import { useGranite } from "@/redux/modules/value/translations/translations.provider";

const NoProductsFound = () => {
    const { t } = useGranite();
    return <p>{t("paintConfigurator.noProductsFound")}</p>;
};

export { NoProductsFound };
